import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import { useSelector } from 'react-redux';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';
import { ADD_TOOLBAR_ID } from 'reactApp/constants/magicIdentificators';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { ToolbarItem } from 'reactApp/ui/Toolbar/ToolbarItem/ToolbarItem';
import { useAddActions } from 'reactApp/ui/Toolbar/useAddActions';

import styles from './Toolbar.css';

interface Props {
    disabled?: boolean;
}

export const AddToolbar = memo(({ disabled }: Props): ReactElement | null => {
    const storage = useSelector(getCurrentStorage) as EStorageType;
    const actions = useAddActions({ storage });

    const isInlineIntegration = storage === EStorageType.inlineIntegration;

    if (!actions.length) {
        return null;
    }

    return (
        <div
            className={classNames(styles.root, styles.root_add, styles.rootFixed, {
                [styles.rootInlineIntegration]: isInlineIntegration,
                [styles.vkTeamsToolbar]: IS_MY_TEAM,
            })}
            id={ADD_TOOLBAR_ID}
            data-qa-id="addToolbar"
        >
            {actions.map(({ id, text, icon, list, dropdownTheme, onClick }) => (
                <ToolbarItem
                    disabled={disabled}
                    key={id}
                    id={id}
                    text={text}
                    icon={icon}
                    list={list}
                    dropdownTheme={dropdownTheme}
                    onClick={onClick}
                />
            ))}
        </div>
    );
});

AddToolbar.displayName = 'AddToolbar';
